"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyCarPolicy = void 0;
function makeEmptyCarPolicy() {
    return {
        policyId: -1,
        policyStatus: '',
        effectiveEndDate: '',
        effectiveStartDate: '',
        certificateNumber: 0,
        brandCode: 0,
        brandDescription: '',
        modelCode: '',
        modelDescription: '',
        versionCode: '',
        plateNumber: '',
        vehicleYear: 0,
        postNumber: 0,
        vehicleType: '',
        vehicleDescription: '',
        serialBody: '',
        serialMotor: '',
        vehicleClass: '',
        vehicleClassDescription: '',
        regUnitVeh: '',
    };
}
exports.makeEmptyCarPolicy = makeEmptyCarPolicy;
//# sourceMappingURL=CarPolicy.js.map